// Booking.js (Updated to send to PHP server as well)
import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { db } from "../firebase";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import "../App.css";
import { Autocomplete } from "@react-google-maps/api";

const Booking = () => {
  const navigate = useNavigate();
  const autocompleteRef = useRef(null);
  const [step, setStep] = useState(1);
  const [form, setForm] = useState({
    services: [],
    frequency: "",
    name: "",
    phone: "",
    email: "",
    address: "",
    date: "",
    message: "",
  });

  const isFormValid = () => {
    return (
      form.name.trim() &&
      form.phone.trim() &&
      form.email.trim() &&
      form.address.trim()
    );
  };
  const onPlaceChanged = () => {
    if (autocompleteRef.current) {
      const place = autocompleteRef.current.getPlace();
      const fullAddress = place.formatted_address;
      setForm((prev) => ({ ...prev, address: fullAddress }));
    }
  };

  const toggleService = (service) => {
    setForm((prev) => ({
      ...prev,
      services: prev.services.includes(service)
        ? prev.services.filter((s) => s !== service)
        : [...prev.services, service],
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const nextStep = () => step < 3 && setStep(step + 1);
  const prevStep = () => step > 1 && setStep(step - 1);

  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async () => {
    setSubmitting(true);
    try {
      await addDoc(collection(db, "bookings"), {
        ...form,
        createdAt: serverTimestamp(),
      });

      await fetch("  https://www.luxesparkle.co.nz/send-booking.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });

      navigate("/thank-you");
    } catch (error) {
      console.error(error);
      alert("Something went wrong.");
      setSubmitting(false); // allow retry if error
    }
  };

  return (
    <div className="booking_wrapper">
      <h2 className="booking_title">
        <span>A clean home</span> should bring <span>peace of mind</span>, not
        stress.
        <br />
        <strong>
          <span>Let us handle the mess</span>
        </strong>
        <br />
        We’re so confident, we offer a{" "}
        <strong>
          <span>200% satisfaction guarantee</span>
        </strong>
      </h2>

      <div className="progress_bar">
        <div style={{ width: `${(step / 3) * 100}%` }}></div>
      </div>

      {step === 1 && (
        <div className="booking_step active">
          <h5>
            Step 1: <span>Choose Services</span>
          </h5>
          <div className="service_grid">
            {[
              "Home Cleaning",
              "Commercial Cleaning",
              "Airbnb Cleaning",
              "Carpet Cleaning",
              "After Builder & Open Home Cleaning",
            ].map((s) => (
              <div
                key={s}
                className={`service_box ${
                  form.services.includes(s) ? "selected" : ""
                }`}
                onClick={() => toggleService(s)}
              >
                {s}
              </div>
            ))}
          </div>
          <div className="booking_buttons">
            <button
              className="next_button"
              onClick={nextStep}
              disabled={form.services.length === 0}
            >
              Next
            </button>
          </div>
        </div>
      )}

      {step === 2 && (
        <div className="booking_step active">
          <h5>
            Step 2: <span>Service Frequency</span>
          </h5>
          <div className="frequency_buttons">
            {["One-Off", "Recurring"].map((f) => (
              <button
                key={f}
                className={form.frequency === f ? "selected" : ""}
                onClick={() => setForm({ ...form, frequency: f })}
              >
                {f}
              </button>
            ))}
          </div>
          <div className="booking_buttons">
            <button className="back_button" onClick={prevStep}>
              Back
            </button>
            <button
              className="next_button"
              onClick={nextStep}
              disabled={!form.frequency}
            >
              Next
            </button>
          </div>
        </div>
      )}

      {step === 3 && (
        <div className="booking_step active">
          <h5>
            Step 3: <span>Your Details</span>
          </h5>
          <div className="booking_form">
            <input
              type="text"
              name="name"
              placeholder="Name"
              onChange={handleChange}
              required
            />
            <input
              type="tel"
              name="phone"
              placeholder="Phone Number"
              onChange={handleChange}
              required
            />
            <input
              type="email"
              name="email"
              placeholder="Email"
              onChange={handleChange}
              required
            />
            <Autocomplete
              onLoad={(ref) => (autocompleteRef.current = ref)}
              onPlaceChanged={onPlaceChanged}
            >
              <input
                type="text"
                placeholder="Enter your address"
                className="location-search-input"
              />
            </Autocomplete>
            {/* <textarea
              name="address"
              placeholder="Address"
              onChange={handleChange}
              required
            /> */}
            <div className="input_wrapper">
              <label className="input_label">Preferred Date</label>
              <input
                type="date"
                name="date"
                value={form.date}
                onChange={handleChange}
                id="date_input"
              />
            </div>
            {/* <input
    type="date"
    name="date"
    placeholder="Preferred Date"
    onChange={handleChange}
  /> */}
            <textarea
              name="message"
              placeholder="How can we help you?"
              onChange={handleChange}
            />
          </div>

          <div className="booking_buttons">
            <button className="back_button" onClick={prevStep}>
              Back
            </button>
            <button
              className="next_button"
              onClick={handleSubmit}
              disabled={submitting || !isFormValid()}
            >
              {submitting ? "Submitting..." : "Finish"}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Booking;
